﻿//Jquery
import "./jquery-global.js";
import $, {ajax} from "jquery";
import {loaderShow, loaderHide} from "./loader";

import Dropzone from "dropzone";
let artWorkFileUploadError=null;

export function initArtWorkUploader() {
    const form = document.querySelector('form[data-file="pending-orders"]');
    if (form) {
        let artWorkDropzone = new Dropzone('form[data-file="pending-orders"]', {
            paramName: "files",
            maxFilesize: 10,//MB
            acceptedFiles: "image/*",
            parallelUploads:1,
            uploadMultiple:true,
            //previewTemplate: document.querySelector('[drop-zone-template]')?.innerHTML,
            params: {
                id: form.querySelector('input[name="Id"]').value,
                __RequestVerificationToken: form.querySelector('input[name="__RequestVerificationToken"]').value
            },
            dictDefaultMessage: "<div class=\"upload-block border-0 p-4\"> <img src=\"/Content/images/icons/upload-icon.svg\" alt=\"upload icon\"> <span class=\"fw-bold fs-16 fs-md-20 d-lg-inline d-block mt-lg-0 mt-2 text-primary\"> Drop your files here, or click to select from your computer </span> </div>",
            sending: () => {
                loaderShow(form);
            },
            error: (file, message) => {
                // artWorkFileUploadError = message;
                artWorkFileUploadError = "An error occurred while uploading the file to the server";
            },
            queuecomplete: () => {
                refreshUploadedFileList();
            },
            complete: file => {
                loaderHide(form);
            }
        });
    }
}

function refreshUploadedFileList() {
    const form = document.querySelector('form[data-file="pending-orders"]');
    if (form) {
        let customerFiles = document.querySelector('[data-id="customer-artworks"]');
        loaderShow(customerFiles);
        ajax({
            url: "/QuotePage/GetCustomerArtworks",
            type: "POST",
            data: {
                guid: form.querySelector('input[name="Guid"]').value,
                __RequestVerificationToken: form.querySelector('input[name="__RequestVerificationToken"]').value
            },
            success: data => {
                $('[data-id="customer-artworks"]').replaceWith(data);
            },
            complete: () => {
                loaderHide(customerFiles);
                setTimeout(()=>{
                    if (artWorkFileUploadError) {
                        $('[data-id="error-holder"]').html('<div class="alert alert-danger alert-dismissible fade show" role="alert">' + artWorkFileUploadError + '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button></div>')
                        artWorkFileUploadError = null;
                    }
                },500)
            }
        });
    }
    
}